/**
 * Component & Layout name registry — lightweight string-only.
 *
 * Used by the route validator (and any code that only needs to
 * verify a component/layout name exists) WITHOUT importing the
 * heavy lazy-component map. Keeping these separate prevents
 * Vite from pulling every page's chunk into the initial graph
 * when route validation runs on the public homepage.
 */

export const COMPONENT_NAMES: ReadonlySet<string> = new Set([
  // Public
  "HomePage","BrowseCigars","BrowseBrands","BrowseVitolas","BrowseManufacturers",
  "BrowseRetailers","BrowseDistributors","BrowseLounges","CigarDetail","CigarProfile",
  "BrandDetail","VitolaDetail","ManufacturerDetail","ChannelDetail","Plans",
  "EventsPage","EventDetail","EventRegister","MyEvents","CulturePage","CultureArticle",
  "ReviewsPage","Auth","ResetPassword","MembershipSuccess","Profile","ProfileEdit",
  "ConsumerProfile","BrandOnboarding","BrandOnboardingCapacity","BrandClaim","BrandCreate",
  "Onboarding","TradeOnboarding","AppOnboarding","AccessDenied",
  "ConsumerHome","ConsumerLanding","DiscoverWorld","DiscoverCountry","Discover","RegionDetail",
  "DashboardSettings","DashboardReviews","DashboardHumidors","DashboardSmokingLog","DashboardInsights",
  // Admin (kept for validation only — actual import map lives in component-registry.ts)
  "AdminNewsletter","AdminDataQuality","AdminPlatformInsights","AdminMedia","AdminJobHealth",
  "AdminUsers","AdminBusinesses","AdminRetailerMonetisation","AdminSettings",
  "AdminCrmDashboard","AdminCrmCommand","AdminCrmPipeline","AdminCrmRequests","AdminSitemap","AdminSites",
  // Misc
  "ClubEvents","DashboardBrands","DashboardCigars","Dashboard","NotFound",
  "BusinessPreview","TradePreview","VitolierPreview",
]);

export const LAYOUT_NAMES: ReadonlySet<string> = new Set([
  "PublicLayout","ConsumerLayout","TradeLayout","AdminLayout","BrandOwnerLayout","DashboardLayout",
]);

export function isValidComponentName(name: string | null | undefined): boolean {
  if (!name) return false;
  return COMPONENT_NAMES.has(name);
}

export function isValidLayoutName(name: string | null | undefined): boolean {
  if (!name || name === "—") return true;
  return LAYOUT_NAMES.has(name);
}
